import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// import JS files
import useFetch from "../../../../context/useFetch";
import PanelTemplate from "../../../shares/PanelTemplate";
import MuiButton from "../../../shares/MuiButton";
import PanelFilter from "../../../shares/PanelFilter";
import MuiPagination from "../../../shares/MuiPagination";
// import AddRing from "./AddRing";
// import RingCard from "./RingCard";
import { fixNumbers } from "../../../../utils";
import AddTableRing from "./AddTableRing";
import PanelTable from "../../../shares/PanelTable";
import ShowRingSizes from "../../../customer-panels/create-order/ShowRingSizes";
import CanRingOrdered from "./CanRingOrdered";
import RemoveTableRing from "./RemoveTableRing";
import EditTableRing from "./EditTableRing";

const headersList = [
  { colName: "code", name: "کد" },
  { colName: "brand_name", name: "برند" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "seeـweights", name: "مشاهده وزن‌ها" },
  { colName: "can_ordered", name: "قابل سفارش" },
  { colName: "edite_ring", name: "ویرایش" },
  { colName: "delete_ring", name: "حذف" },
];

const mobileHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand_name", name: "برند" },
];
const dataKey = ["code", "brand_name", "show_name", "gender", "color"];

const TableRing = (props) => {
  let windowWidth = window.screen.width;

  const [openAddRingModal, setOpenAddRingModal] = useState(false);
  const handleModal = () => {
    setOpenAddRingModal((before) => !before);
  };

  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });

  const [brandsList, setBrandsList] = useState({ results: [] });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const [codeFilter, setCodeFilter] = useState(null);
  const [nameFilter, setNameFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);

  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
      isLTR: true,
    },
    {
      type: "textField",
      label_fa: "اسم",
      label_en: "name",
      state: nameFilter,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",
      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
  ];
  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });
  const [ringsList, setRingsList] = useState({ results: [] });
  const getRingsApi = useFetch({
    method: "get",
    url: "Bangle_Service",
    pagination: paginationPageInfo,
    params: {
      code: fixNumbers(codeFilter),
      brand: brandFilter,
      name: nameFilter,
    },
    trigger: true,
    setter: setRingsList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "name") setNameFilter(e.length > 0 ? e : null);
    if (state == "brand") setBrandFilter(e);
  };
  const filter = () => {
    getRingsApi.reFetch();
  };

  const reset_filter = () => {
    setCodeFilter(null);
    setNameFilter(null);
    setBrandFilter(null);
    getRingsApi.reFetch();
  };
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    getRingsApi.reFetch();
  };

  const buttonsList = [
    {
      label: "مشاهده وزن‌ها",
      component: (it) => <ShowRingSizes selectedRow={it} />,
    },
    {
      label: "قابل سفارش",
      component: (it) => (
        <CanRingOrdered getRingsApi={getRingsApi} selectedRow={it} />
      ),
    },
    {
      label: "ویرایش ",
      component: (it) => (
        <EditTableRing selectedRow={it} getRingsApi={getRingsApi} />
      ),
    },
    {
      label: "لغو سفارش",
      component: (it) => (
        <RemoveTableRing selectedRow={it} getRingsApi={getRingsApi} />
      ),
    },
  ];
  const actionsList = [
    // {
    //   label: "افزودن",
    //   component: (it) => (
    //     <AddRingTabThree selectedRow={it} selectedUser={props.selectedUser} />
    //   ),
    // },
  ];

  return (
    <>
      <PanelTemplate sidebarActiveLink="table-rings">
        <div className="panel-main-header">
          <span>مدیریت النگو‌ها</span>
        </div>
        <div className="add-item-container">
          <span className="text">
            برای اضافه کردن النگوی جدید روی دکمه افزودن کلیک کنید.
          </span>
          <MuiButton
            onClick={handleModal}
            variant="outlined"
            icon={<AddIcon />}
            color="secondary"
            text="افزودن"
          />
        </div>
        {openAddRingModal && (
          <AddTableRing
            openModal={openAddRingModal}
            setOpenModal={setOpenAddRingModal}
            getRingsApi={getRingsApi}
          />
        )}
        <PanelFilter
          header="فیلتر النگوها:"
          list={filterList}
          update_filter={update_filter}
          filter={filter}
          reset_filter={reset_filter}
        />
        <PanelTable
          header="محصولات:"
          headers={headersList}
          mobileHeaders={mobileHeadersList}
          data={ringsList.results}
          dataKey={dataKey}
          buttons={buttonsList}
          actions={actionsList}
          icon={<AccountBalanceIcon />}
        />
        <MuiPagination
          onChange={onChangePage}
          count={Math.ceil(
            paginationPageInfo.count / paginationPageInfo.pageSize
          )}
        />
      </PanelTemplate>
    </>
  );
};

export default TableRing;
